import { RestService } from "../common/rest-service";

export class ProfessionalProfileService extends RestService {
  constructor() {
    super();
    this.getProfessional = this.getProfessional.bind(this);
    this.getFullProfessionalProfile = this.getFullProfessionalProfile.bind(this);
  }

  /**
        Função para ter acesso ao perfil do usuário
    
        @returns {promise} Informações do usuário
    */
  async getProfessional() {
    return await this.get("/lacreisaude/professional/");
  }

  /**
        Função para ter acesso ao perfil do usuário completo
    
        @returns {promise} Informações do usuário
    */
  async getFullProfessionalProfile() {
    return await this.get("/lacreisaude/user/");
  }
}
